import { ENROLLMENT_STATUSES, type EnrollmentStatus } from '@ctms/contracts';

/**
 * English labels of the nine participation statuses (element 11 of the Cockpit
 * legend). The customer asked for the clinical status names to stay in English
 * and without a translation (mail of 2026-10-14, item 6 of the "six remarks"
 * batch) — these replace the Polish wording accepted in session 18.
 * `REQ-PAT-014` already lists the same nine statuses under their English names.
 *
 * One canonical map for the whole cockpit: the status filter of the
 * participant list (element 5/11) and the chart bar (element 6) show the same
 * person state, so the labels live here instead of being copied per component.
 */
export const ENROLLMENT_STATUS_LABELS: Record<EnrollmentStatus, string> = {
  [ENROLLMENT_STATUSES.PRE_SCREENING]: 'Pre-screening',
  [ENROLLMENT_STATUSES.SCREENED]: 'Screened',
  [ENROLLMENT_STATUSES.ONGOING]: 'Ongoing',
  [ENROLLMENT_STATUSES.FOLLOW_UP]: 'Follow-up',
  [ENROLLMENT_STATUSES.COMPLETED]: 'Completed',
  [ENROLLMENT_STATUSES.WITHDRAWN]: 'Withdrawn',
  [ENROLLMENT_STATUSES.SCREENING_FAILURE]: 'Screening failure',
  [ENROLLMENT_STATUSES.PRE_SCREENING_FAILURE]: 'Pre-screening failure',
  [ENROLLMENT_STATUSES.LOST_TO_FOLLOW_UP]: 'Lost to follow-up',
};